import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltungen-angelegte-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungenAngelegteAdminEffects {

    VeranstaltungenAngelegteAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNGEN_ANGELEGTE_ADMIN),
        mergeMap((x: ac.GetVeranstaltungenAngelegteAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungenAngelegteAdmin().pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungenAngelegteAdminErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungenAngelegteAdminFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
